import * as React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import { useRef, useEffect, useState } from "react";
import { DateTime } from "enums";
import { formatDate, parseDate } from "react-day-picker/moment";
import classNames from "classnames";
import styles from "./date-picker.module.scss";
import { Calendar } from "images";
import Image from "../image/image";
import moment from "moment";
import { useMemo } from "react";

const DatePickerV2 = ({
  value,
  onChange,
  name,
  disabled,
  placeholder,
  className,
  disableStartDate,
  disableEndDate,
}) => {
  const datePickerRef = useRef();
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (!value) {
      setResetKey((k) => k + 1);
    }
  }, [value]);

  const modifiers = useMemo(() => {
    let modifiers = null;
    let disabled = [];
    if (disableStartDate) {
      disabled.push({
        before: new Date(disableStartDate),
      });
    }
    if (disableEndDate) {
      disabled.push({
        after: new Date(disableEndDate),
      });
    }

    if (disabled.length) {
      modifiers = { disabled };
    }
    return modifiers;
  }, [disableStartDate, disableEndDate]);

  return (
    <div
      className={classNames(styles.container, className, {
        [`${styles.disabled}`]: disabled,
      })}
    >
      <div className={styles.datePicker}>
        {disabled ? (
          <div>{value ? moment(value).format(DateTime.A) : placeholder}</div>
        ) : (
          <DayPickerInput
            key={resetKey}
            ref={datePickerRef}
            value={value}
            placeholder={placeholder}
            format={DateTime.A}
            formatDate={formatDate}
            parseDate={parseDate}
            inputProps={{
              onChange: (e) => {
                if (e.target.value.length > 11) {
                  const today = moment();
                  const todayFormatted = today.format(DateTime.A);
                  datePickerRef.current.getInput().value = todayFormatted;
                  onChange(name, { value: today.toDate() });
                }
              },
              onBlur: () => {
                const inputEl = datePickerRef.current?.getInput();
                if (!inputEl || !inputEl.value.trim()) return;
                const inputValue = inputEl.value.trim();
                const date = moment(inputValue, DateTime.A, true);

                if (!date.isValid()) {
                  const fallback =
                    disableStartDate && moment(disableStartDate).isAfter(moment())
                      ? new Date(disableStartDate)
                      : new Date();
                  inputEl.value = moment(fallback).format(DateTime.A);
                  onChange(name, { value: fallback });
                  return;
                }

                if (disableStartDate && date.isBefore(moment(disableStartDate))) {
                  onChange(name, { value: new Date(disableStartDate) });
                } else if (disableEndDate && date.isAfter(moment(disableEndDate))) {
                  onChange(name, { value: new Date(disableEndDate) });
                }
              },
            }}
            onDayChange={(date) => {
              // if (!disabled) {
              //   const today = moment().startOf("day");
              //   if (moment(date).isBefore(today)) {
              //     const todayFormatted = today.format(DateTime.A);
              //     datePickerRef.current.getInput().value = todayFormatted;
              //     onChange(name, { value: today.toDate() });
              //     return;
              //   }
              //   onChange(name, { value: date });
              // }

              onChange(name, { value: date });
            }}
            onBlur={() => {
              const inputValue = datePickerRef.current.getInput().value.trim();
              const today = moment().startOf("day");

              if (inputValue.length > 11) {
                const todayFormatted = today.format(DateTime.A);
                datePickerRef.current.getInput().value = todayFormatted;
                onChange(name, { value: today.toDate() });
                return;
              }

              const parsedDate = moment(inputValue, DateTime.A, true);
              if (!parsedDate.isValid() || parsedDate.isBefore(today)) {
                const todayFormatted = today.format(DateTime.A);
                datePickerRef.current.getInput().value = todayFormatted;
                onChange(name, { value: today.toDate() });
              }
            }}
            disabled={disabled}
            dayPickerProps={{
              disabled,
              numberOfMonths: 1,
              modifiers: modifiers,
            }}
          />
        )}
        <Image
          className={styles.icon}
          src={Calendar}
          onClick={() => datePickerRef.current?.getInput().focus()}
        />
      </div>
    </div>
  );
};

export default DatePickerV2;
